module.exports = __webpack_public_path__ + "img/rfid-wristband.c714f9b6.svg";